import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import { useFormik } from "formik";
import jwt_decode from "jwt-decode";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate, useLocation } from "react-router";
import FBannerSpendResponsive from "../../components/FBannerSpendResponsive/FBannerSpend";
import FcardPaymentMethod from "../../components/FcardPaymentMethod/FcardPaymentMethod";
import FInput from "../../components/FInput/FInput";
import { QRCode } from "react-qrcode-logo";
import { useProcessor } from "../../hooks/useProcessor";
import { v4 as uuidv4 } from "uuid";
import { useBank } from "../../hooks/useBank";
import { AuthContext } from "../../context/AuthContext";
import { useCurrencyFormat } from "../../hooks/useCurrencyFormat";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
// import required modules
import { EffectCoverflow, Pagination } from "swiper";
import FcardBank from "../../components/FcardBank/FcardBank";
import FBillContainer from "../../components/FBillContainer/FBillContainer";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import FInputt from "../../components/FInputt/FInputt";
import { useFormat } from "../../hooks/useFormat";
import { CloseOutline } from "react-ionicons";

const CheckScreen = ({ param }) => {
  const token = localStorage.getItem("token");
  const tokenDecode = jwt_decode(token);
  const { processPayment } = useProcessor();
  const MySwal = withReactContent(Swal);
  const { checkPassword } = useFormat();
  const [idempotencyKey, setIdempotencyKey] = useState(null);
  const route = useNavigate();
  const { setAlert, signIn } = useContext(AuthContext);

  const { formatWithCurrencyISO } = useCurrencyFormat();

  const parameters = useLocation();
  const { transferredAmount, originCurrency } = parameters.state;

  const { banks, getBankByCountry, setBanks, selectCard, setSelectCard } =
    useBank();

  useEffect(() => {
    console.log(tokenDecode);
    setIdempotencyKey(uuidv4());
    getBankByCountry(840);
    if (banks === null) {
      setBanks([]);
    }
  }, []);

  return (
    <>
      <div className="max-w-[700px] mx-auto px-4 sm:px-6 md:px-8">
        <div className="w-full border-0">
          <Swiper
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={2}
            coverflowEffect={{
              rotate: 10,
              stretch: 5,
              depth: 50,
              modifier: 3,
              slideShadows: false,
            }}
            modules={[EffectCoverflow, Pagination]}
            className="w-full border-0"
            onSlideChange={(e) => {
              setSelectCard({
                index: e.realIndex,
                id: banks[e.realIndex].id,
              });
              console.log(banks[e.realIndex].id);
            }}
          >
            {banks
              .map((b) => {
                return {
                  id: b.id,
                  bankName: b.alias,
                  accountNumber: b.accountNumber,
                };
              })
              .map((bank, index) => (
                <SwiperSlide className="mx-2">
                  <div className="lg:w-[990px]">
                    <div
                      className={
                        selectCard.index == index ? "border-0" : "hidden"
                      }
                    >
                      <div className="bg-green-400 rounded-full w-9 h-9 absolute">
                        <div className="w-full  grid place-items-center pt-[10px]">
                          <ion-icon name={"checkmark"}></ion-icon>
                        </div>
                      </div>
                    </div>
                    <div className="pt-3">
                      <FcardBank arrayBanks={[bank]} />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
        <div className="w-full border-0 grid place-items-center my-5">
          <div className="w-[330px] sm:w-[430px] border-0 text-end font-bold text-Secondary cursor-pointer">
            Agregar nueva cuenta
          </div>
        </div>
        <div className="w-full border-0 grid place-items-center">
          <div className="w-[330px] sm:w-[430px]">
            <FBillContainer
              total={formatWithCurrencyISO(transferredAmount, originCurrency)}
              btnTitle="Continuar"
              btnOnChange={() => {
                MySwal.fire({
                  showCloseButton: true,
                  showCancelButton: false,
                  showConfirmButton: false,
                  html: (
                    <MySwalbody
                      MySwal={MySwal}
                      tokenDecode={tokenDecode}
                      parameters={parameters.state}
                      selectCard={selectCard}
                      idempotencyKey={idempotencyKey}
                      processPayment={processPayment}
                      signIn={signIn}
                    />
                  ),
                });
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

const MySwalbody = (props) => {
  const { checkPassword } = useFormat();
  const {
    productId,
    transferredAmount,
    originCurrency,
    destinationCurrencyId,
    idFiadoFlash,
  } = props.parameters;

  const nextScreen = async (data) => {
    let response = await props.processPayment(data, props.idempotencyKey);
    console.log(response);
    // if (response?.data?.code == "PROCESS_OK") {
    //   setCart([]);

    //   Alert.alert("Éxito", "Se ha recargado la cuenta", [
    //     {
    //       text: "Aceptar",
    //       onPress: () => navigation.navigate("HomeScreen"),
    //     },
    //   ]);
    // }

    // if (true == true && props.idempotencyKey) {
    //   // let response = await props.processPayment(data, props.idempotencyKey);
    //   // console.log(response);
    //   // if (response?.data?.code == "PROCESS_OK") {

    //   //     setCart([])

    //   //     Alert.alert('Éxito', 'Se ha recargado la cuenta', [
    //   //         {
    //   //             text: 'Aceptar',
    //   //             onPress: () => navigation.navigate('HomeScreen')
    //   //         }])

    //   // }
    // }
  };

  const formik = useFormik({
    initialValues: {
      username: props.tokenDecode.phoneNumber,
      password: "",
    },
    onSubmit: async (values) => {
      const data = {
        destinationCurrencyId: parseInt(destinationCurrencyId),
        exchangeRateId: props.idempotencyKey,
        originCurrencyId: parseInt(originCurrency),
        products: [
          {
            id: idFiadoFlash,
            amount: transferredAmount,
          },
          {
            id: productId,
            paymentMethod: {
              paymentMethodId: props.selectCard.id,
              password: values.password,
            },
          },
        ],
      };
      nextScreen(data);
    },
    validate: (values) => {
      const errors = {};
      if (!values.password) {
        errors.password = "Ingresa una contraseña.";
      } else {
        if (values.password.length < 6) {
          errors.password = "Tu contraseña debe tener al menos 6 caracteres.";
        } else {
          if (!checkPassword(values.password)) {
            errors.password =
              "Escribe una contraseña valida. (Usa letras, numeros y signos)";
          }
        }
      }
      return errors;
    },
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="border-0 grid place-items-center pt-3">
          <img
            src={require("../../components/assets/images/password.png")}
            className="w-[100px] sm:w-32"
          />
          <div className="font-bold text-large text-black">
            Ingresa tu contraseña
          </div>
          <div className=" border-0 w-full text-large text-black mt-1 px-5 xs:px-14">
            <FInputt
              type="password"
              name="password"
              title=""
              placeholder="Ingresa tu contraseña"
              formik={formik}
              maxLength={15}
              onChange={(e) => {
                formik.setFieldValue("password", e);
              }}
            />
          </div>
          <div className="font-regular text-[15px] text-black mt-5">
            <FInputt
              type="botton"
              disabled={formik.isValid && formik.dirty}
              className={
                !(formik.isValid && formik.dirty)
                  ? "px-[90px] py-[12px] xs:px-[120px] md:py-[12px] rounded-2xl text-black bg-colorDisabled"
                  : "px-[90px] py-[12px] xs:px-[120px] md:py-[12px] rounded-2xl   text-white bg-primary"
              }
              title="Continuar"
              onChange={formik.handleSubmit}
            />
          </div>
        </div>
      </form>
    </>
  );
};
export default CheckScreen;
